import { Component, inject } from '@angular/core';
import {
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  LinkComponent,
} from '@components';
import { CONFIG } from '@config';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss',
  imports: [
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    LinkComponent,
  ],
})
export class ErrorComponent {
  domainId = inject(CONFIG).domainId;
}
